import { useQuery } from '@apollo/client';
import PurchaseOrderAggregateQuery from '../../graphql/queries/purchases/PurchaseOrderAggregateQuery.graphql';
import { FilterOperation, IFilterInput, Maybe } from '../../graphql/schema/p4types';
import { useTotalQuery } from './SupplierOverviewTab';
import PurchaseTransaction from '../../graphql/entities/supplier/PurchaseTransaction';
import PurchaseInvoice from '../../graphql/entities/supplier/PurchaseInvoice';

const usePurchaseOrderTotals = (filters: Array<IFilterInput>, skip: boolean) => {
  const { data: ordersData } = useQuery(PurchaseOrderAggregateQuery, {
    variables: {
      filters: filters,
      aggregateCriteria: {
        sumColumns: ['goodsAmountOutstanding'],
      },
    },
    fetchPolicy: 'network-only',
    skip,
  });

  let data = {
    orderValue: 0,
  };

  if (!ordersData) return data;

  data.orderValue = ordersData.listData.totalColumns[0].sum; //Only fetching one column for the moment so always [0].

  return data;
};
export const useSupplierTotals = (supplierDotIdFilter: Array<IFilterInput>, supplierId: Maybe<number>) => {
  const orders = usePurchaseOrderTotals(supplierDotIdFilter, !supplierId);

  const disputedInvoicesFilters: Array<IFilterInput> = [
    ...supplierDotIdFilter,
    { filterOperation: FilterOperation.Equals, filterParameters: { field: 'held', value: 'true' } },
    { filterOperation: FilterOperation.GreaterThan, filterParameters: { field: 'outstandingAmount', value: '0' } },
  ];

  const invoicesAwaitingApprovalFilters: Array<IFilterInput> = [
    ...supplierDotIdFilter,
    { filterOperation: FilterOperation.Equals, filterParameters: { field: 'documentStatus', value: 'DRAFT' } },
  ];

  const outstandingSum = useTotalQuery(PurchaseTransaction.aggregate, {
    filters: disputedInvoicesFilters,
    sumColumn: 'outstandingAmount',
    skip: !supplierId,
  });

  const awaitingApprovalSum = useTotalQuery(PurchaseInvoice.aggregate, {
    filters: invoicesAwaitingApprovalFilters,
    sumColumn: 'documentAmount',
    skip: !supplierId,
  });

  return { orders, outstandingSum, awaitingApprovalSum };
};
